import { useAtom } from 'jotai'
import { useFlags } from 'launchdarkly-react-client-sdk'

import {
  isContractExtractionEnabledExternallyAtom,
  loadableExtractionResultAtom,
  performExtractionAtom
} from 'ContractExtraction/atoms'
import { useCurrentContract } from './useContract'

type UsePerformContractExtraction = () => {
  isEnabled: boolean
  performExtraction: (assetId: string) => void
}

export const usePerformContractExtraction: UsePerformContractExtraction =
  () => {
    const flags = useFlags()

    const { data: contractData } = useCurrentContract()

    const [extractionResult] = useAtom(loadableExtractionResultAtom)
    const [, performExtraction] = useAtom(performExtractionAtom)
    const [isExtractionEnabledExternally] = useAtom(
      isContractExtractionEnabledExternallyAtom
    )

    const isFlagEnabled = Boolean(flags?.useContractIntakePrototype)
    const isNotExtracting = extractionResult.state !== 'loading'
    const isNotAlreadyExtracted = !contractData

    const isEnabled: boolean =
      isFlagEnabled &&
      isNotExtracting &&
      isNotAlreadyExtracted &&
      isExtractionEnabledExternally

    return {
      isEnabled,
      performExtraction: (assetId: string) => {
        if (!isEnabled) return
        performExtraction(assetId)
      }
    }
  }
